<div class="rs-panel-flex">
  <div class="rs-panel-flex-cell rs-bg-grey2 clearfix">
    <div class="rs-flex-row rs-flex-middle-small-only">
      <div
        class="panel rs-inline-block rs-wd-s14 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading"
      ></div>
    </div>
    <div class="rs-flex-row rs-flex-middle-small-only">
      <div
        class="panel rs-maxw rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
      ></div>
    </div>
  </div>
</div>
